import { render, staticRenderFns } from "./modifierGroup.vue?vue&type=template&id=0c9a865a&scoped=true"
import script from "./modifierGroup.vue?vue&type=script&lang=js"
export * from "./modifierGroup.vue?vue&type=script&lang=js"
import style0 from "./modifierGroup.vue?vue&type=style&index=0&id=0c9a865a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a865a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9a865a')) {
      api.createRecord('0c9a865a', component.options)
    } else {
      api.reload('0c9a865a', component.options)
    }
    module.hot.accept("./modifierGroup.vue?vue&type=template&id=0c9a865a&scoped=true", function () {
      api.rerender('0c9a865a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/editor/itemConfig/modifierGroup.vue"
export default component.exports